export enum MessageStatus {
    Draft = 'draft',
    Processing = 'processing',
    Scheduled = 'scheduled',
    Sent = 'sent',
    Failed = 'failed',
}